import hasAlreadyConsented from "./hasAlreadyConsented";

// See https://www.clickskeks.at/so-gehts/expertenfunktionen/api#c3512
export default function onUserHasConsentedToCookies(category /*e.g. 'statistics' or 'preference'*/, callback, executeInBackend = true) {
    if (document.body.classList.contains('neos-backend')) {
		// there's no cookie manager in the backend
		if(executeInBackend) {
			callback();
		}
		return;
    }

    if (!window.Clickskeks) {
        console.error('There is no clickskeks loaded on ' + location.href);
        return;
    }

    if (hasAlreadyConsented(category)) {
        callback();
        return;
    }

    let clickskeksAllowedConfigCallback = function (allowedConfig) {
        if (allowedConfig[category]) {
            callback();
            window.Clickskeks.removeAllowedConfigChangedCallback(clickskeksAllowedConfigCallback);
        }
    }
    window.Clickskeks.addAllowedConfigChangedCallback(clickskeksAllowedConfigCallback);
}
